import { Table } from "src/components/ui";
import usePagination from "src/hooks/usePagination";
import { AdminTableContainer } from "../admin/admin-style";
import { PaginationProps } from "../ui/Pagination";
import { useEffect } from "react";
import { FC, useState } from "react";

const BankTable: FC<{
  rows: any;
  Ppage: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  paginationData: PaginationProps;
}> = ({ rows, Ppage, setPage, paginationData }) => {
  const AdminTableHeaders = [
    { title: "ID", render: (row: any) => `${row.id}` },
    { title: "Slug Name", render: (row: any) => `${row.slug}` },
    { title: "Bank Name", render: (row: any) => `${row.name}` },
    { title: "Pay with Bank", render: (row: any) => `${row.pay_with_bank}` },
  ];
  const { page, limit, Pagination } = usePagination(
    {
      page: Ppage,
      limit: 10,
      total: rows.length,
      setPageNo: setPage,
    },
    paginationData,
  );
  const [paginatedRows, setPaginatedRows] = useState<[]>([]);
  useEffect(() => {
    // setPaginatedRows(rows.slice((page - 1) * limit, page * limit));
    setPaginatedRows(rows);
  }, [page, limit, rows]);

  return (
    <AdminTableContainer>
      <div className="heading">
        <p className="count">{rows.length} Banks</p>
      </div>
      <Table rows={paginatedRows} headers={AdminTableHeaders} showHead={true} />
      <Pagination />
    </AdminTableContainer>
  );
};

export default BankTable;
